export default (base) => {
  return {
    Reference (field, icon, className, finder) {
      return {
        label: `${base}.list.filter.${field}`,
        field,
        icon,
        type: 'object',
        cardinality: 'single',
        render: 'stringRep',
        schema: {
          route: className.toLowerCase(),
          className
        },
        finder
      }
    },

    ReferenceByMultiValueSearchRep (field, icon, className = field) {
      return {
        label: `${base}.list.filter.${field}`,
        field,
        icon,
        type: 'object',
        cardinality: 'single',
        render: 'stringRep',
        schema: {
          route: className.toLowerCase(),
          className
        },
        finder: {
          name: 'byMultiValueSearchRep',
          multiValue: true,
          minLength: 4
        }
      }
    },

    ReferenceBySearchRep (field, icon, className = field) {
      return {
        label: `${base}.list.filter.${field}`,
        field,
        icon,
        type: 'object',
        cardinality: 'single',
        render: 'stringRep',
        schema: {
          route: className.toLowerCase(),
          className
        },
        finder: {
          name: 'bySearchRepLike',
          multiValue: false,
          minLength: 0
        }
      }
    },

    String (field) {
      return {
        label: `${base}.list.filter.${field}`,
        field,
        type: 'string'
      }
    },

    Boolean (field) {
      return {
        label: `${base}.list.filter.${field}`,
        field,
        type: Boolean
      }
    },

    Number (field, icon) {
      return {
        label: `${base}.list.filter.${field}`,
        type: Number,
        field,
        icon
      }
    },

    kumuliert () {
      return {
        label: `${base}.list.filter.kumuliert`,
        field: 'kumuliert',
        type: Boolean,
        narrow: true,
        view (data) {
          let visible = data.organisationseinheit != null && data.organisationseinheit.name !== ''
          visible = visible || data.organisationseinheiten != null && data.organisationseinheiten.name !== ''
          if (!visible) data.kumuliert = false
          return visible
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/schema/list/ListFilterFieldsGeneric.js